import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Calendar } from '../ui/calendar';

interface DatePickerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  mode: 'start' | 'end';
  startDate: string | null;
  endDate: string | null;
  onSelect: (date: string) => void;
}

export const DatePickerDialog = ({
  open,
  onOpenChange,
  title,
  mode,
  startDate,
  endDate,
  onSelect,
}: DatePickerDialogProps) => {
  const selectedValue = mode === 'start'
    ? (startDate ? new Date(startDate) : undefined)
    : (endDate ? new Date(endDate) : undefined);

  const isDisabled = (date) => {
    if (mode === 'end' && startDate) return date < new Date(startDate);
    if (mode === 'start' && endDate) return date > new Date(endDate);
    return date > new Date();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[350px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="flex justify-center py-4">
          <Calendar
            mode="single"
            selected={selectedValue}
            onSelect={(date) => {
              if (date) {
                onSelect(date.toISOString());
                onOpenChange(false);
              }
            }}
            disabled={isDisabled}
            className="rounded-md border"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
